import { AbstractControl } from '@angular/forms';

export default function invalidMonth(control: AbstractControl) {
  if (control && control.value && control.value.length) {
    const value: string = control.value;
    const tokens = value.split('/');
    const monthToken = tokens[0];
    const month = parseInt(monthToken, 10);

    if (month < 1 || month > 12) {
      return {
        invalidMonth: true,
      };
    }
  }
  return null;
}
